import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextField,
  ReferenceField,
  SelectInput,
  required,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import { JsonInput } from "react-admin-json-view";
import { MERCHANT_PAYMENT_GATEWAY_STATUSES } from "@local/app/constants/index.js";
import { CustomToolbar, Title } from "../../shared/components/index.js";

const renderOptionText = (record) => (
  <span key={record.id}>
    <img
      src={record?.url}
      width={15}
      height={15}
      style={{ marginRight: "5px" }}
      alt={record.name}
    />
    {record.name}
  </span>
);

const editMerchantPaymentGateway = () => (
  <Edit
    redirect="show"
    title={<Title source="name" />}
    mutationMode="pessimistic"
  >
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextField source="name" />

      <ReferenceField source="payment_gateway_id" reference="PaymentGateway">
        <TextField source="name" />
      </ReferenceField>

      <ReferenceInput source="logo_file_id" reference="File">
        <AutocompleteInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          inputText={(record) => record.name}
          optionText={renderOptionText}
          optionValue="id"
          debounce={10}
          filterToQuery={(searchText) => ({ name: searchText })}
        />
      </ReferenceInput>

      <BooleanInput source="default" />
      <JsonInput
        source="config"
        reactJsonOptions={{
          name: null,
          collapsed: false,
          enableClipboard: false,
          displayDataTypes: false,
        }}
      />
      <SelectInput
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
        source="status"
        validate={[required()]}
        choices={Object.keys(MERCHANT_PAYMENT_GATEWAY_STATUSES)
          .filter(
            (status) =>
              status !== MERCHANT_PAYMENT_GATEWAY_STATUSES.blocked.name
          )
          .map((status) => ({
            id: status,
            name: `resources.Merchant.source.status.${status}`,
          }))}
      />
    </SimpleForm>
  </Edit>
);

export default editMerchantPaymentGateway;
